module.exports = __webpack_public_path__ + "img/violet_062.4e8c6dbf.png";